export const formatDateTimeToISOFormat = (scheduleDate: string, scheduleTime: string): string | number | Date => {
  let [dia, mes, ano] = scheduleDate.split("/");
  let [hora, minuto] = scheduleTime.split(":");

  return `${ano}-${mes}-${dia}T${hora}:${minuto}:00`;
}

/**
 * Data/hora local de Brasília sem sufixo Z (ex.: 2026-08-04T14:00:00).
 * Evita gravar UTC via toISOString() em colunas datetime sem timezone.
 */
export const formatDateTimeBrasilia = (date: Date = new Date()): string => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(date);

  const value = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? '00';

  return `${value('year')}-${value('month')}-${value('day')}T${value('hour')}:${value('minute')}:${value('second')}`;
};

export const formatISOFormatToDate = (iso: string): string => {
  let [ano, mes, dia] = iso.split("-");
  dia = dia.slice(0,2);

  return `${dia}/${mes}/${ano}`;
}

export const getDayName = (dayNumber: string) => {
  switch (dayNumber) {
    case 'Do':
      return 'D';
    case '2ª':
      return 'S';
    case '3ª':
      return 'T';
    case '4ª':
      return 'Q';
    case '5ª':
      return 'Q';
    case '6ª':
      return 'S';
    case 'Sá':
      return 'S';
  }
}

export const getDayNameExtenso = (dayNumber: number) => {
  switch (dayNumber) {
    case 0: return 'domingo'
    case 1: return 'segunda-feira'
    case 2: return 'terça-feira'
    case 3: return 'quarta-feira'
    case 4: return 'quinta-feira'
    case 5: return 'sexta-feira'
    case 6: return 'sábado'
  }
}

export const formatDateIso = (dateString: string) => {
  const [day, month, yearAndTime] = dateString.split('/');
  const [year, time] = yearAndTime.split(' ');

  const formattedString = `${year}-${month}-${day}T${time}`;

  const date = new Date(formattedString);

  return date.toISOString();
}